/* eslint-disable */
import { gsap } from "gsap";


export default function initMarquee() {
  const arraySections = [];
  let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
  let prevScrolText = '';
  document.querySelectorAll('.text-marque-holder').forEach((section) => {
    const wrapper  =section.querySelector('.marquee-wrapper');
    const isReversed = wrapper.getAttribute("data-reverse") === "true";
    const template = wrapper.querySelector(".marquee-template");
    if (!template) return;

    const wrapperWidth = wrapper.offsetWidth;
    const trackWidth = template.offsetWidth;


    const count = Math.ceil(wrapperWidth / trackWidth) + 2;
    for (let i = 1; i < count; i++) {
      const clone = template.cloneNode(true);
      clone.setAttribute('aria-hidden', true);
      clone.classList.remove("marquee-template");
      if(i % 2) {
        wrapper.appendChild(clone);
      } else {
        wrapper.prepend(clone);
      }
    }

    const tracks = wrapper.querySelectorAll(".marquee-track");

    gsap.set(wrapper, {xPercent: -50});

    let  direction = isReversed ? `+=${trackWidth}` : `-=${trackWidth}`;

    const scene = gsap.to(tracks, {
      x: direction,
      modifiers: {
        x:  (x) => `${parseFloat(x) % trackWidth}px`,
      },
      ease: "none",
      duration: 10 * template.clientWidth / window.innerWidth,
      repeat: -1,
      // yoyo: true
    });

    arraySections.push({  
      scene,
      template,
      tracks,
      wrapper,
      isReversed
    })
    
  });

  function callback(text, currentScroll){
    arraySections.forEach((obj)=>{
      const trackWidth = obj.template.offsetWidth;
      let  direction;
      let x;
      if(!obj.isReversed) {
        direction = (text === 'down' )? `+=${trackWidth}` : `-=${trackWidth}`;
         x = (text === 'down' )? 0 : -400;
      } else {
        direction = (text === 'up' )? `+=${trackWidth}` : `-=${trackWidth}`;
         x = (text === 'up' )? 0 : -400;
      }
      obj.scene.vars.x = direction;
      obj.scene.kill();
      obj.scene = gsap.to(obj.tracks, {
        x: direction,
        modifiers: {
          x:  (x) => `${parseFloat(x) % trackWidth}px`,
        },
        ease: "none",
        duration: 10 * obj.template.clientWidth / window.innerWidth,
        repeat: -1,
        // yoyo: true
      });
      
      gsap.to(obj.wrapper, {
        x,
        duration: 1,
        ease: "power2.out",
      })

    })

  }
  window.addEventListener('scroll', (e)=> {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop) {
      if(prevScrolText !== 'down') {
        prevScrolText = 'down';
        callback('down', currentScroll);
      }
    } else if (currentScroll < lastScrollTop) {
      if(prevScrolText !== 'up') {
        prevScrolText = 'up';
        callback('up', currentScroll);
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; 
  });
}